// import
import { domInsert, getBlockNodes } from '../utils/angular-helpers'
import { keys, isEqual, isString, difference, intersection } from 'lodash-es'

import setCss from '../utils/set-css'

export function recalcClass(reg) {
  const raw = reg.cmdfunc()
  const curr = raw === null ? '' : raw
  if (isString(curr)) {
    if (curr === reg.last) return
    reg.$elm.removeClass(reg.last)
    reg.$elm.addClass(curr)
    reg.last = curr
  } else {
    if (isEqual(curr, reg.last)) return
    const currCL = keys(curr).filter((key) => !!curr[key])
    const lastCL = keys(reg.last).filter((key) => !!reg.last[key])
    const newCL = difference(currCL, lastCL)
    const delCL = difference(lastCL, currCL)
    if (newCL.length) newCL.forEach((key) => reg.$elm.addClass(key))
    if (delCL.length) delCL.forEach((key) => reg.$elm.removeClass(key))
    reg.last = curr
  }
}

export function recalcStyle(reg) {
  const curr = reg.cmdfunc()
  if (isEqual(curr, reg.last)) return
  const currKeys = keys(curr)
  const lastKeys = keys(reg.last)
  const stbKeys = intersection(currKeys, lastKeys)
  const newKeys = difference(currKeys, lastKeys)
  const delKeys = difference(lastKeys, currKeys)
  if (stbKeys.length) stbKeys.forEach((key) => setCss(reg.$elm, key, curr[key]))
  if (newKeys.length) newKeys.forEach((key) => setCss(reg.$elm, key, curr[key]))
  if (delKeys.length) delKeys.forEach((key) => setCss(reg.$elm, key, null))
  reg.last = curr
}

const DISPLAY_NONE = 'none'
const DISPLAY_INIT = ''

export function recalcShow(reg) {
  const curr = reg.cmdfunc()
  if (curr === reg.last) return
  const cssVal = curr ? DISPLAY_INIT : DISPLAY_NONE
  setCss(reg.$elm, 'display', cssVal)
  reg.last = curr
}

export function recalcHide(reg) {
  const curr = reg.cmdfunc()
  if (curr === reg.last) return
  const cssVal = curr ? DISPLAY_NONE : DISPLAY_INIT
  setCss(reg.$elm, 'display', cssVal)
  reg.last = curr
}

export function recalcAttr(reg) {
  const curr = reg.cmdfunc()
  if (isEqual(curr, reg.last)) return
  const currKeys = keys(curr)
  const lastKeys = keys(reg.last)
  const stbKeys = intersection(currKeys, lastKeys)
  const newKeys = difference(currKeys, lastKeys)
  const delKeys = difference(lastKeys, currKeys)
  if (stbKeys.length) stbKeys.forEach((key) => reg.$elm.attr(key, curr[key]))
  if (newKeys.length) newKeys.forEach((key) => reg.$elm.attr(key, curr[key]))
  if (delKeys.length) delKeys.forEach((key) => reg.$elm.attr(key, null))
  reg.last = curr
}

export function recalcProp(reg) {
  const curr = reg.cmdfunc()
  if (isEqual(curr, reg.last)) return
  const currKeys = keys(curr)
  const lastKeys = keys(reg.last)
  const stbKeys = intersection(currKeys, lastKeys)
  const newKeys = difference(currKeys, lastKeys)
  const delKeys = difference(lastKeys, currKeys)
  if (stbKeys.length) stbKeys.forEach((key) => reg.$elm.prop(key, curr[key]))
  if (newKeys.length) newKeys.forEach((key) => reg.$elm.prop(key, curr[key]))
  if (delKeys.length) delKeys.forEach((key) => reg.$elm.prop(key, null))
  reg.last = curr
}

export function recalcBind(reg) {
  const curr = reg.cmdfunc()
  if (curr === reg.last) return
  reg.$elm.text(curr)
  reg.last = curr
}

export function recalcIf(reg) {
  const curr = reg.cmdfunc()
  if (curr === reg.last) return
  reg.last = curr

  if (curr) {
    reg.$transclude(($childElm, $childScope) => {
      reg.$childElm = $childElm
      reg.$childScope = $childScope
      domInsert($childElm, reg.$elm.parent(), reg.$elm)
    })
  } else {
    if (reg.$childScope) {
      reg.$childScope.$destroy()
      reg.$childScope = null
    }
    if (reg.$childElm) {
      getBlockNodes(reg.$childElm).remove()
      reg.$childElm = null
    }
  }
}

export function recalcReset(reg) {
  if (reg.$childScope) {
    reg.$childScope.$destroy()
    reg.$childScope = null
  }
  if (reg.$childElm) {
    getBlockNodes(reg.$childElm).remove()
    reg.$childElm = null
  }
  reg.$transclude(($childElm, $childScope) => {
    reg.$childScope = $childScope
    reg.$childElm = $childElm
    domInsert($childElm, reg.$elm.parent(), reg.$elm)
  })
}
